import { component_tool, framework_tool } from '../../../tool';
let { WizModal, WizNotice, WizTooltip } = component_tool;
import moment from "moment";
import React from 'react';
let { WizDataTable, WizIcon, WizButton, WizDivider, WizSurveyAudience, WizTypography, WizRow } = component_tool
let { WizAvatarUpload, ossFileUtils } = framework_tool
import HighSet from "@/containers/common/highSet";

let ref;
//配置项
let componentName = 'homework'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "标题",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {
      width: 400,
      // render: (text, record) => {
      //   return <WizTooltip className='appy-verify-text' title={text}>
      //     <div className='appy-verify-text' >
      //       {text}
      //     </div>
      //   </WizTooltip >
      // }
    }
  },
  {
    title: "分类",
    name: "categoryName",
    dataIndex: "categoryName",
    tableItem: {
      width: 100
    }
  },
  {
    title: "分类",
    name: "categoryId",
    dataIndex: "categoryId",
    searchItem: {
      type: 'treeselect',
      allowClear: true,
      dict: {
        wizReplaceData: "treeData",
        defalutType: []
      },
    }
  },
  {
    title: "状态",
    name: "statusList",
    dataIndex: "state",
    searchItem: {
      type: 'select',
      mode: 'multiple',
      formatInit: () => [0,1]
    },
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "已发布" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已结束" }
    ],
  },
  /* {
    title: "状态",
    name: "state",
    dataIndex: "state",
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "已发布" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已结束" }
    ],
    searchItem: {
      type: "select"
    },
  },
 */
  {
    title: "开始时间",
    name: "startDate",
    dataIndex: "startDate",
    width: 150,
    tableItem: {}
  },
  {
    title: "结束时间",
    name: "endDate",
    dataIndex: "endDate",
    width: 150,
    tableItem: {}
  },
  {
    title: "是否需要批阅",
    name: "reviewType",
    dataIndex: "reviewType",
    tableItem: {
      width: 100
    },
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 0, codeName: "人工" },
      // { code: 1, codeName: "智能" },
      { code: 2, codeName: "无需批阅" },
    ],
  },
  {
    title: "是否公开展示",
    name: "open",
    dataIndex: "open",
    tableItem: {
      width: 100
    },
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" },
    ],
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {
    },
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "已发布" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已结束" }
    ],
  },
  {
    title: "作业时间",
    name: "searchDate",
    dataIndex: "searchDate",
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  }

];

const templateConfig = (data) => {
  let {pathname} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (val) => {
            if (val['searchDate'] && val['searchDate'].length === 2) {
              val['startDate'] = moment(val['searchDate'][0]).format("YYYY-MM-DD")
              val['endDate'] = moment(val['searchDate'][1]).format("YYYY-MM-DD")
            }
            // delete val['searchDate']
            return val
          },
          buttonSort: ['add', "export"],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: pathname + "/homeworkAdd"
                }
              }
            },
            {
              key: "export",
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export"
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            }

          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['update', 'look', 'release', 'unpublish', 'jobRecord', 'advancedSet'],
        rowOperateView: [

          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/homeworkUpd"
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && record.record.state === 2) {
                result.disabled = true
              }
              return result
            },
          },
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/homeworkInfo"
              }
            }
          },
          {
            key: "release",
            custom: true,
            params: { children: "发布" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState"
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '您确定修改[' + record.name + ']状态为已发布吗?'
                if (record.state == 1) {
                  WizNotice.warn('该作业已是发布状态,不可重复操作');
                  return null;
                }
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: 1,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              },
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: false };
              if (record.record && (record.record.state === 1 || record.record.state === 2 || record.record.state === 3)) {
                result.disabled = true
              }
              return result
            },
          },
          {
            key: "unpublish",
            custom: true,
            params: { children: "取消发布" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState"
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '取消发布后，本次作业将作废，您确定要取消发布吗？'
                if (record.state == 2) {
                  WizNotice.warn('该作业已是取消发布状态,不可重复操作');
                  return null;
                }
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: 2,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              },
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: true };
              if (record.record && record.record.state === 1) {
                result.disabled = false
              }
              return result
            },
          },
          {
            key: "jobRecord",
            custom: true,
            params: { children: "作业记录" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/homeworkRecordList"
              }
            },
            recordChangeParams: (record, rows) => {
              let result = { disabled: true };
              if (record.record && record.record.state) {
                result.disabled = false
              }
              return result
            },
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: e.record, bizType: 30 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['state'] !== 1) {
                disabled = true
              }
              return { disabled }
            }
          },
        ],
        commonOperate: {}
      }
    }
  }
};

const apis = (params = {}) => {
  return{
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, statusList: [0,1], ...(params || {}) }
      }
    },
    updateState: {
      path: `${componentName}/updateState`,
      payload: {
        key: `${componentName}@updateState`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { statusList: [0,1], ...(params || {}) }
      }
    },
    treeData: {
      path: `questionType/nodeList`,
      payload: {
        key: `questionType@treeData`,
        apiParams: { type: 11 }
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis: apis(args['params']),
    componentName,
    initApiKeys: ['list', 'treeData'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
